import Yup from "../localizedYup";
import moment from "moment";
import { RULES } from "Constants/rules";

var _groupBy = require("lodash/groupBy");

Yup.addMethod(Yup.array, "TimeRangeCheck", function (message) {
  return this.test("unique", message, function (value) {
    if (!!!value) return true;
    if (value.length <= 0) return true;

    const conditions = [...value];

    if (
      conditions.some(
        (s) => s.dateOfBeginning === null || !!s.dateOfFinish === null
      )
    )
      return true;

    const sortedConditions = conditions.sort((previous, current) => {
      let prev = moment(previous.dateOfBeginning);
      let curr = moment(current.dateOfBeginning);

      if (prev.isBefore(curr)) {
        return -1;
      }

      if (prev.isSame(curr)) {
        return 0;
      }

      return 1;
    });
    var groupedConditions = _groupBy(sortedConditions, function (condition) {
      return `${condition.purpose?.id}-${condition.type?.id}`;
    });
    for (const [key, value] of Object.entries(groupedConditions)) {
      let result = value.reduce(
        (result, current, idx, arr) => {
          if (idx === 0) {
            return result;
          }
          var previous = arr[idx - 1];

          // check for any overlap
          var previousEnd = moment(previous.dateOfFinish).startOf("day");
          var currentStart = moment(current.dateOfBeginning).startOf("day");
          var overlap = previousEnd.isSameOrAfter(currentStart);

          // store the result
          if (overlap) {
            // yes, there is overlap
            result.overlap = true;
            // store the specific ranges that overlap
            result.ranges.push({
              previous: previous,
              current: current,
            });
          }

          return result;
        },
        { overlap: false, ranges: [] }
      );

      if (result.overlap)
        throw this.createError({
          path: `${this.path}`,
          message,
        });
    }

    return true;
  });
});

const conditionValidationSchema = Yup.object({
  type: Yup.object().required(),
  purpose: Yup.object().required(),
  dateOfBeginning: Yup.date().required(),
  dateOfFinish: Yup.date().nullable(),
  documentAmount: Yup.number().required(),
  documentCurrency: Yup.string().required(),
  frequencyUnit: Yup.object().required(),
  frequencyVal: Yup.number().required(),
  timeRatio: Yup.string().required(),
  maturityUnit: Yup.object(),
  maturityVal: Yup.number(),
  increaseType: Yup.object().nullable(),
  description: Yup.string().max(1000),
});

const conditionsValidationSchema = Yup.array()
  .of(conditionValidationSchema)
  .TimeRangeCheck(
    "Girdiğiniz tarih aralığı listedeki diğer koşullar ile çakışıyor."
  )
  .required("En az bir adet Koşul girmelisiniz");

const validationSchema = Yup.object().shape({
  partner: Yup.object().nullable().required(),
  extensionRule: Yup.object().nullable(),
  notificationType: Yup.object().nullable(),
  mailGroup: Yup.object().nullable(),
  notificationDuration: Yup.number().nullable(),
  timeObject: Yup.string().nullable(),
  description: Yup.string().nullable().required().max(1000),
  dateOfBeginning: Yup.date().nullable().required(),
  dateOfFinish: Yup.date().when(["type", "rentableAreas"], {
    is: (type, rentableAreas) => {
      return (
        type?.rule?.code == RULES.RULE0001 &&
        rentableAreas?.length > 0 &&
        ["TASK", "SERVICE"].includes(
          rentableAreas[0].rentableArea?.allocationType
        )
      );
    },
    then: Yup.date().nullable(),
    otherwise: Yup.date().nullable().required(),
  }),
  dateOfSign: Yup.date().nullable(),
  rentableAreas: Yup.array()
    .of(
      Yup.object({
        id: Yup.number(),
        rentableArea: Yup.object({ id: Yup.number() }),
      })
    )
    .when("type", {
      is: (value) => {
        return value?.rule?.code == RULES.RULE0014;
      },
      then: Yup.array(),
      otherwise: Yup.array().required(),
    }),
});

export {
  validationSchema,
  conditionValidationSchema,
  conditionsValidationSchema,
};
